import React from 'react'
import './button.css'

const button = ({Label, Action}) => {
  return (
    <div>
        <button onClick={Action}>{Label}</button>
    </div>
  )
}

export default button
